import { clearSession, refreshSession } from "./session";

let retryList = [];

const handleUnauthorizedError = async (error, onRetry) => {
  if (error.response?.status === 401) {
    if (error.request.requestURL.includes("/refresh-token")) {
      clearSession();
      alert("Session หมดอายุ\nกรุณา login ใหม่อีกครั้ง");
      window.location.href = "/";
    } else {
      retryList.push(onRetry);
      await refreshSession();
    }
  }
};

export const retryAllPendingRequest = () => {
  retryList.forEach(async (onRetry) => {
    await onRetry();
  });
  retryList = [];
};

export default handleUnauthorizedError;
